<template>
    <div
        class="upload-zone px-8 py-3 border-b transition-colors"
        :class="isDragging ? 'bg-indigo-50 border-indigo-300' : 'bg-gray-50 border-gray-200'"
        @drop.prevent="onDrop"
        @dragover.prevent="isDragging = true"
        @dragleave.prevent="isDragging = false"
        @dragenter.prevent="isDragging = true"
    >
        <div v-if="!uploading" class="flex items-center gap-3">
            <div class="text-sm text-gray-500">
                <i class="far fa-cloud-upload mr-1"></i>
                <span v-if="isDragging" class="text-indigo-600 font-medium">Laat los om te uploaden</span>
                <span v-else>Sleep bestanden hierheen of</span>
            </div>
            <label class="inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 cursor-pointer focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                <i class="far fa-plus mr-1.5 text-gray-400"></i> Bestand kiezen
                <input type="file" class="sr-only" @change="onFileSelect" ref="fileInput" multiple />
            </label>
        </div>

        <div v-else class="flex items-center gap-3">
            <div class="flex-1">
                <div class="text-sm text-gray-600 mb-1.5">
                    <i class="far fa-circle-notch fa-spin mr-1"></i>
                    Uploaden... {{ uploadedCount }}/{{ totalCount }}
                </div>
                <div class="w-full bg-gray-200 rounded-full h-1">
                    <div
                        class="bg-indigo-500 h-1 rounded-full transition-all"
                        :style="{ width: progressPercent + '%' }"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MediaUploadZone',

    props: {
        uploadUrl: { type: String, required: true },
    },

    data() {
        return {
            isDragging: false,
            uploading: false,
            uploadedCount: 0,
            totalCount: 0,
        };
    },

    computed: {
        progressPercent() {
            if (this.totalCount === 0) return 0;
            return Math.round((this.uploadedCount / this.totalCount) * 100);
        },
    },

    methods: {
        onDrop(e) {
            this.isDragging = false;
            var files = e.dataTransfer.files;
            if (files.length) {
                this.uploadFiles(files);
            }
        },

        onFileSelect(e) {
            var files = e.target.files;
            if (files.length) {
                this.uploadFiles(files);
            }
            // Reset input so the same file can be selected again
            this.$refs.fileInput.value = '';
        },

        uploadFiles(files) {
            var self = this;
            self.uploading = true;
            self.uploadedCount = 0;
            self.totalCount = files.length;

            var promises = [];

            for (var i = 0; i < files.length; i++) {
                promises.push(self.uploadSingleFile(files[i]));
            }

            Promise.all(promises)
                .then(function () {
                    self.uploading = false;
                    self.$emit('uploaded');
                    Vue.toasted.show(self.totalCount + ' bestand(en) geüpload', { type: 'success' });
                })
                .catch(function (err) {
                    self.uploading = false;
                    var message = 'Upload mislukt';
                    if (err && err.response && err.response.data && err.response.data.message) {
                        message = err.response.data.message;
                    }
                    Vue.toasted.show(message, { type: 'error' });
                });
        },

        uploadSingleFile(file) {
            var self = this;
            var formData = new FormData();
            formData.append('file', file);

            return axios.post(this.uploadUrl, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            }).then(function () {
                self.uploadedCount++;
            });
        },
    },
};
</script>
